import { render, staticRenderFns } from "./customDialog.vue?vue&type=template&id=23dd63d4&scoped=true&"
import script from "./customDialog.vue?vue&type=script&lang=js&"
export * from "./customDialog.vue?vue&type=script&lang=js&"
import style0 from "./customDialog.vue?vue&type=style&index=0&id=23dd63d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dd63d4",
  null
  
)

export default component.exports